module.exports = __webpack_public_path__ + "static/img/aqy.a364ac40.jpg";